<template>
  <div class="pro_info">
    <div class="address" v-if="orderInfo.consignee">
      <div class="flex_box">
        <span>{{ orderInfo.consignee.name }}</span>
        <span>{{ orderInfo.consignee.tel }}</span>
      </div>
      <div>
        {{ orderInfo.consignee.address }}
      </div>
    </div>
    <div class="pro_list">
      <ul>
        <li v-for="item of orderInfo.order_goods" :key="item.id">
          <div class="pro_box">
            <div class="pro_img">
              <img :src="item.goods_pic" v-if="item.goods_pic" />
            </div>
            <div class="pro_content">
              <div class="pro_name">{{ item.goods_name }}</div>
              <div class="flex_box pro_price">
                <span>{{ $setInfoDecimal(item.goods_price) }} </span>
                <span>X{{ item.goods_num }}</span>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="total-box">
        <span>总计:</span>
        <span v-if="orderInfo.payment"> {{ $setInfoDecimal(orderInfo.payment.order_price) }} </span>
      </div>
      <div class="order_info">
        <div class="head">订单信息</div>

        <div>
          <span>支付状态:</span>
          <span> {{ orderInfo.pay_status ? "已支付" : "未支付" }}</span>
        </div>
        <div>
          <span>货物状态:</span>
          <span v-if="orderInfo.order_status"> {{
              orderInfo.order_status | orderStatus
          }}</span>
        </div>
        <div>
          <span>订单编号:</span> <span>{{ orderInfo.order_sn }}</span>
        </div>
        <div>
          <span>订单时间:</span> <span>{{ orderInfo.add_time }}</span>
        </div>
      </div>
    </div>
    <div class="btn_group">
      <button @click="payHandle" v-if="orderInfo.order_status === 1">去支付</button>
      <button @click="cancelOrder" v-if="orderInfo.order_status === 2">取消订单</button>
      <button @click="isShowService = true" v-if="orderInfo.order_status === 3 || orderInfo.order_status === 4"> 申请售后
      </button>
      <button @click="logistics" v-if="orderInfo.order_status === 3 || orderInfo.order_status === 4">查看物流</button>
    </div>

    <van-popup v-model="isShowService" closeable :style="{ height: '90%', width: '90%' }">
      <serviceInfo></serviceInfo>
    </van-popup>
  </div>
</template>
<script>
  import { getOrderinfo, payDopay, cancelorder, repay } from "@/api/order"
  import { orderStatus } from '@/utils/orderType'
  import serviceInfo from '@/components/serviceInfo'
  import { Popup, Dialog } from 'vant';


  function payInfSort(info) {
    return info.sort(function (a, b) {
      if (a.payType < b.payType) {
        return -1;
      } else if (a.payType == b.payType) {
        return 0;
      } else {
        return 1;
      }
    });
  }

  export default {
    components: {
      [Popup.name]: Popup,
      [Dialog.name]: Dialog,
      serviceInfo
    },
    data() {
      return {
        orderInfo: {},
        isShowService: false
      }
    },
    methods: {
      // 获取商品详情
      async getInfo() {
        const order_sn = this.$route.query.odId
        const result = await getOrderinfo({
          order_sn: order_sn
        })
        this.orderInfo = result.data.data.orderInfo
      },
      async payDopay(pay_id) {
        const result = await payDopay({
          pay_id: pay_id
        })
        this.$toast(result.data.data.message)
        return result.data.data
      },
      async rePay() {
        const { orderInfo } = this
        const result = await repay({
          order_sn: orderInfo.order_sn,
          payment_type: 1
        })

        this.$toast(result.data.data.message)
        return result.data.data

      },
      // 支付处理
      payHandle() {
        const { orderInfo, payDopay, rePay } = this
        Dialog.confirm({
          title: '是否提交支付'
        }).then(async () => {

          if (orderInfo.order_status === 1) {
            const result = await rePay()
            console.log(result)
            if (result.status) {
              this.$router.go(0)
            }
            return
          }


          if (orderInfo.order_status === 2 && orderInfo.pay_info.length !== 0) {
            // 排序支付顺序
            const payInfo = payInfSort(orderInfo.pay_info)
            // 处理支付
            payInfo.forEach(async (item) => {
              if (item.payType === 1) {
                const result = await payDopay(item.pay_id)
                if (result.status) {
                  this.$router.go(0)
                }
              }
            })
          } else {
            this.$toast('订单支付失败, 请稍后再试')
          }

        }).catch(() => { });
      },
      // 取消订单
      async cancelOrder() {
        try {
          const result = await cancelorder({ order_sn: this.orderInfo.order_sn });
          this.$toast(result.data.data.message)
          if (result.data.data.cancel_status) {
            this.$router.replace({
              name: 'My'
            })
          }
        } catch (err) { }
      },
      // 确认收货
      // async confirm () {
      //   const { orderInfo } = this
      //   const result = await confirmOrder({
      //     order_sn: orderInfo.order_sn
      //   })
      //   this.$toast(result.data.data.message)
      //   try {
      //     if (result.data.data.status) {
      //       this.$router.replace({
      //         name: 'My'
      //       })
      //     }
      //   } catch (err) { }
      // },
      logistics() {
        this.$router.push({
          name: 'logistic',
          query: {
            id: this.orderInfo.order_sn
          }
        })
      }
    },
    filters: {
      orderStatus(value) {
        const result = orderStatus.find(item => { return value === item.id })
        return result.title
      }
    },
    created() {
      this.getInfo()
    }
  }
</script>
<style lang="scss" scoped>
.flex_box {
  display: flex;
  justify-content: space-around;
}

.pro_info {
  font-size: 0.28rem;
  // height: 50vh;
  background: linear-gradient(to bottom, $globalcolor, #fff);
  padding-top: 0.3rem;
}

.pro_list {
  font-size: 0.28rem;
  width: 6.78rem;
  margin: 0.1rem auto;

  background: #fff;
  border-radius: 5px;

  ul {
    border-radius: 10px;

    li {
      .pro_box {
        display: flex;
        justify-content: space-between;
        padding: 0.2rem;
        margin: 0.2rem auto;
        width: 6.3rem;
        border-bottom: 1px solid #eee;
      }

      .pro_img {
        width: 1.71rem;
        height: 1.71rem;
      }

      .pro_content {
        width: 4.3rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .pro_name {
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .pro_price {
          font-weight: 800;
        }
      }

      // .logistics {
      //   margin-left: 0.12rem;
      //   text-align: right;
      //   padding: 0 0.1rem;
      //   button {
      //     font-size: 0.2rem;
      //     border: 0;
      //     background: $globalcolor !important;
      //     padding: 0.1rem 0.3rem;
      //     color: #fff;
      //     border-radius: 10px;
      //   }
      // }
    }
  }
}

.address {
  width: 6.38rem;
  font-size: 0.28rem;
  margin: 0 auto;
  background: #fff;
  padding: 0.3rem 0.2rem;
  border-radius: 5px;
}

.btn_group {
  display: flex;
  justify-content: space-evenly;
  position: fixed;
  bottom: 0rem;
  width: 100%;
  font-size: 0.28rem;
  padding: 0.15rem 0 calc(0.15rem + env(safe-area-inset-bottom)) 0;
  background: #fff;

  button {
    width: 2.34rem;
    padding: 0.15rem 0;
    border-radius: 30px;
    border: none;
  }

  :nth-child(1) {
    border: 1px solid $globalcolor;
    color: $globalcolor;
    background: #fff;
  }

  :nth-child(2) {
    background: $globalcolor;
    color: #fff;
  }
}

.order_info {
  padding: 0.2rem;
  padding-bottom: calc(2rem + env(safe-area-inset-bottom));

  .head {
    font-size: 0.31rem;
    font-weight: 600;
  }

  div {
    margin: 0.1rem 0;
  }
}

.total-box {
  text-align: right;
  padding: 0.1rem 0.2rem;
}
</style>